export interface GraphData {
  '@odata.context': string;
  businessPhones: string[];
  displayName: string;
  givenName: string;
  jobTitle: string;
  mail: string;
  mobilePhone: string | null;
  officeLocation: string;
  preferredLanguage: string;
  surname: string;
  userPrincipalName: string;
  id: string;
}

export enum UserRole {
  CHECKPOINT_MANAGER = 'CheckpointManager',
  DR_VIEWER = 'DRView',
  NETWORK_VIEWER = 'NetworkView',
  NOVA_VIEWER = 'NOVAView',
  RELEASE_NOTES_MANAGER = 'ReleaseNotesManager',
}

export interface UserRoleAccess {
  accessibleEndpoints: {
    methods: string[];
    path: string;
    supportedApiVersions: string[];
    versioningURLs: string[];
  }[];
  user: {
    name: string;
    email: string;
    roles: UserRole[];
  };
}
